/**
 * Parse HTML table and extract investment data with price history
 * @param {string} html - HTML string containing the table
 * @param {string} investmentId - Investment ID for reference
 * @returns {Object} Parsed investment data
 */
function parseInvestmentTable(html, investmentId) {
  // Create a temporary DOM element to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  const investments = [];
  const rows = tempDiv.querySelectorAll('.netby-table-row.netby-row');

  rows.forEach(row => {
    const cells = row.querySelectorAll('.netby-cell');
    if (cells.length < 5) return; // Skip if not enough cells

    const investment = {
      id: cells[0] && cells[0].textContent ? cells[0].textContent.trim() : '',
      priceHistory: [],
    };

    // Extract price history from data attributes - combine total price and price per sqm
    const totalPriceElement =
      cells[4] && cells[4].querySelector('[data-netbyapp-price-history]');
    const pricePerSqmElement =
      cells[5] && cells[5].querySelector('[data-netbyapp-price-history]');

    if (totalPriceElement && pricePerSqmElement) {
      const totalPriceData = totalPriceElement.getAttribute(
        'data-netbyapp-price-history'
      );
      const pricePerSqmData = pricePerSqmElement.getAttribute(
        'data-netbyapp-price-history'
      );

      try {
        const totalPriceHistory = JSON.parse(
          totalPriceData.replace(/&quot;/g, '"')
        );
        const pricePerSqmHistory = JSON.parse(
          pricePerSqmData.replace(/&quot;/g, '"')
        );

        if (
          Array.isArray(totalPriceHistory) &&
          Array.isArray(pricePerSqmHistory)
        ) {
          // Combine price histories by datetime
          const combinedHistory = {};

          totalPriceHistory.forEach(entry => {
            combinedHistory[entry.datetime] = {
              price: entry.price,
              datetime: entry.datetime,
            };
          });

          pricePerSqmHistory.forEach(entry => {
            if (combinedHistory[entry.datetime]) {
              combinedHistory[entry.datetime].pricePerSqm = entry.price;
            } else {
              combinedHistory[entry.datetime] = {
                pricePerSqm: entry.price,
                datetime: entry.datetime,
              };
            }
          });

          investment.priceHistory = Object.values(combinedHistory);
        }
      } catch (e) {
        console.warn('Failed to parse price history:', e);
      }
    }

    investments.push(investment);
  });

  return {
    investmentId,
    apartments: investments,
  };
}

export function fetchInvestmentData(investmentId) {
  const url = 'https://app.netbyapp.pl/api/generate-table';

  const requestBody = {
    investment_ids: [investmentId],
    filters: {},
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network error: ${response.status}`);
      }
      return response.text();
    })
    .then(data => {
      const result = JSON.parse(data);
      if (result.success !== 1) {
        throw new Error('API returned unsuccessful response');
      }

      // Find the table with matching investment_id
      let tableData = null;
      if (result.tables && Array.isArray(result.tables)) {
        tableData = result.tables.find(
          table => table.investment_id === investmentId
        );
      } else if (result.html) {
        // If there's direct html, use it
        tableData = { html: result.html, investment_id: investmentId };
      }

      if (!tableData) {
        throw new Error(`No table found for investment ID: ${investmentId}`);
      }

      // Parse HTML and extract investment data
      const investmentData = parseInvestmentTable(tableData.html, investmentId);

      window.priceHistory = investmentData;

      return {
        investmentData,
      };
    })
    .catch(error => {
      console.error('Error fetching investment data:', error);
      throw error;
    });
}



// WEBPACK FOOTER //
// ./scripts/components/fetchHistory.js